export default [
  {
    path: "/cryptoConfigurations/countries",
    component: () => import(/* webpackChunkName: "layout" */ "../layout"),

    children: [
      {
        path: ":id",
        props: true,
        name: "crypto.countries.show",
        component: () => import(/* webpackChunkName: "crypto.countries" */ "./show.vue"),
      },
    ],
  },
];
